import { css, useTheme } from "@emotion/react";

const DotBounce = () => {
    const theme = useTheme();

    const dotBounceCss = css`
        height: 60px;
        aspect-ratio: 2;
        border-bottom: 3px solid #0000;
        background: linear-gradient(
                90deg,
                ${theme.colors.black.light60.asHex} 50%,
                #0000 0
            ) -25%
            100%/50% 3px repeat-x border-box;
        position: relative;
        animation: l3-0 0.75s linear infinite;

        &&:before {
            content: "";
            position: absolute;
            inset: auto 42.5% 0;
            aspect-ratio: 1;
            border-radius: 50%;
            background: ${theme.colors.primary.asString};
            animation: l3-1 0.75s cubic-bezier(0, 900, 1, 900) infinite;
        }
        @keyframes l3-0 {
            to {
                background-position: -125% 100%;
            }
        }
        @keyframes l3-1 {
            0%,
            2% {
                bottom: 0%;
            }
            98%,
            to {
                bottom: 0.1%;
            }
        }
    `;

    return <div css={dotBounceCss} />;
};

export { DotBounce };
